var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/react/index.ts
var react_exports = {};
__export(react_exports, {
  Bender1: () => Bender1_default,
  Bender2: () => Bender2_default,
  Bender3: () => Bender3_default,
  Bender4: () => Bender4_default,
  Bender5: () => Bender5_default,
  Blooblob1: () => Blooblob1_default,
  Blooblob2: () => Blooblob2_default,
  Blooblob3: () => Blooblob3_default,
  Blooblob4: () => Blooblob4_default,
  Blooblob5: () => Blooblob5_default,
  Chaos1: () => Chaos1_default,
  Chaos2: () => Chaos2_default,
  Chaos3: () => Chaos3_default,
  Chaos4: () => Chaos4_default,
  Chaos5: () => Chaos5_default,
  Firebob1: () => Firebob1_default,
  Firebob2: () => Firebob2_default,
  Firebob3: () => Firebob3_default,
  Firebob4: () => Firebob4_default,
  Firebob5: () => Firebob5_default,
  Firebob6: () => Firebob6_default,
  Glitchy1: () => Glitchy1_default,
  Glitchy2: () => Glitchy2_default,
  Glitchy3: () => Glitchy3_default,
  Glitchy4: () => Glitchy4_default,
  Glitchy5: () => Glitchy5_default,
  Igor1: () => Igor1_default,
  Igor2: () => Igor2_default,
  Igor3: () => Igor3_default,
  Igor4: () => Igor4_default,
  Igor5: () => Igor5_default,
  Inkly1: () => Inkly1_default,
  Inkly2: () => Inkly2_default,
  Inkly3: () => Inkly3_default,
  Inkly4: () => Inkly4_default,
  Inkly5: () => Inkly5_default,
  Maddog1: () => Maddog1_default,
  Maddog2: () => Maddog2_default,
  Maddog3: () => Maddog3_default,
  Maddog4: () => Maddog4_default,
  Maddog5: () => Maddog5_default,
  Reaper1: () => Reaper1_default,
  Reaper2: () => Reaper2_default,
  Reaper3: () => Reaper3_default,
  Reaper4: () => Reaper4_default,
  Reaper5: () => Reaper5_default
});

// src/react/Bender1.tsx
import * as React from "react";
function SvgBender1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M89.338 47.557H60.65c-19.253 0-34.86 15.607-34.86 34.86v.011c0 19.253 15.607 34.861 34.86 34.861h28.688c19.253 0 34.861-15.608 34.861-34.86v-.012c0-19.253-15.608-34.86-34.86-34.86Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M41.396 31.884A30.485 30.485 0 0 1 71.88 62.358v11.837H41.396v-42.31Zm67.208 0v42.322H78.119V62.358a30.485 30.485 0 0 1 30.485-30.473Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M62.457 71.694h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M63.56 58.975h-7.44v7.44h7.44v-7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M56.418 58.975h-7.44v7.44h7.44v-7.44Zm39.324 0h-7.44v7.44h7.44v-7.44Zm7.494 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M62.457 79.133h-7.44v7.44h7.44v-7.44Zm7.44-7.439h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M69.897 79.133h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M62.457 82.858h-7.44v11.165h7.44V82.858Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M69.897 86.583h-7.44v7.44h7.44v-7.44Zm20.389-14.889h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.286 79.133h-7.44v7.44h7.44v-7.44Zm7.44-7.439h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M97.726 79.133h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M90.286 82.858h-7.44v11.165h7.44V82.858Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M97.726 86.583h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Bender1_default = SvgBender1;

// src/react/Bender2.tsx
import * as React2 from "react";
function SvgBender2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React2.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React2.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M89.338 47.557H60.65c-19.253 0-34.86 15.607-34.86 34.86v.011c0 19.253 15.607 34.861 34.86 34.861h28.688c19.253 0 34.861-15.608 34.861-34.86v-.012c0-19.253-15.608-34.86-34.86-34.86Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M41.396 31.884A30.485 30.485 0 0 1 71.88 62.358v11.837H41.396v-42.31Zm67.208 0v42.322H78.119V62.358a30.485 30.485 0 0 1 30.485-30.473Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M60.948 65.478h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M68.387 65.478h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M60.948 69.192h-7.44v11.165h7.44V69.191Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M68.387 72.917h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M82.638 96.536h-7.44v7.439h7.44v-7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M90.077 96.536h-7.44v7.439h7.44v-7.44Zm-13.975 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M96.491 90.011h-7.439v7.44h7.44v-7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M88.776 65.478h-7.439v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M96.216 65.478h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M88.776 69.192h-7.439v11.165h7.44V69.191Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React2.createElement("path", {
    d: "M96.216 72.917h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Bender2_default = SvgBender2;

// src/react/Bender3.tsx
import * as React3 from "react";
function SvgBender3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React3.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React3.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M89.338 47.557H60.65c-19.253 0-34.86 15.607-34.86 34.86v.011c0 19.253 15.607 34.861 34.86 34.861h28.688c19.253 0 34.861-15.608 34.861-34.86v-.012c0-19.253-15.608-34.86-34.86-34.86Z",
    fill: "#fff"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M41.418 31.885A30.485 30.485 0 0 1 71.903 62.37v11.826H41.418V31.874v.01Zm67.23 0v42.31h-30.53V62.36a30.485 30.485 0 0 1 30.53-30.474Z",
    fill: "#fff"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "m54.026 68.09 14.438.363-.518 20.235-7.219-.176.254-10.118-7.208-.187.253-10.117Zm25.272.639 14.438.364-.507 20.235-7.219-.177.254-10.117-7.22-.187.254-10.118Z",
    fill: "#9514FF"
  }));
}
var Bender3_default = SvgBender3;

// src/react/Bender4.tsx
import * as React4 from "react";
function SvgBender4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React4.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React4.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M89.338 47.557H60.65c-19.253 0-34.86 15.607-34.86 34.86v.011c0 19.253 15.607 34.861 34.86 34.861h28.688c19.253 0 34.861-15.608 34.861-34.86v-.012c0-19.253-15.608-34.86-34.86-34.86Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "M41.418 31.885A30.485 30.485 0 0 1 71.903 62.37v11.826H41.418V31.874v.01Zm67.23 0v42.31h-30.53V62.36a30.485 30.485 0 0 1 30.53-30.474Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React4.createElement("path", {
    d: "m54.026 68.09 14.438.363-.518 20.235-7.219-.176.254-10.118-7.208-.187.253-10.117Zm25.272.639 14.438.364-.507 20.235-7.219-.177.254-10.117-7.22-.187.254-10.118Z",
    fill: "#fff"
  }));
}
var Bender4_default = SvgBender4;

// src/react/Bender5.tsx
import * as React5 from "react";
function SvgBender5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React5.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React5.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "M89.338 47.557H60.65c-19.253 0-34.86 15.607-34.86 34.86v.011c0 19.253 15.607 34.861 34.86 34.861h28.688c19.253 0 34.861-15.608 34.861-34.86v-.012c0-19.253-15.608-34.86-34.86-34.86Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "M41.418 31.885A30.485 30.485 0 0 1 71.903 62.37v11.826H41.418V31.885Zm67.23 0v42.321h-30.53V62.358a30.484 30.484 0 0 1 30.53-30.473Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React5.createElement("path", {
    d: "m54.026 69.192 14.438.364-.518 20.235-7.219-.177.254-10.117-7.208-.188.253-10.117Zm25.272.639 14.438.364-.507 20.246-7.219-.188.254-10.117-7.22-.187.254-10.118Z",
    fill: "#F7FC17"
  }));
}
var Bender5_default = SvgBender5;

// src/react/Blooblob1.tsx
import * as React6 from "react";
function SvgBlooblob1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React6.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React6.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React6.createElement("path", {
    d: "M120.165 116.837H29.79V61.201A37.902 37.902 0 0 1 67.694 23.3H82.22a37.902 37.902 0 0 1 37.902 37.902v55.636h.044Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React6.createElement("path", {
    d: "M55.14 56.694h14.438v20.235h-7.22V66.81H55.14V56.694Zm25.283 0H94.86v20.235h-7.22V66.81h-7.218V56.694Z",
    fill: "#FF5509"
  }));
}
var Blooblob1_default = SvgBlooblob1;

// src/react/Blooblob2.tsx
import * as React7 from "react";
function SvgBlooblob2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React7.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React7.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React7.createElement("path", {
    d: "M120.165 116.837H29.79V61.201A37.902 37.902 0 0 1 67.694 23.3H82.22a37.902 37.902 0 0 1 37.902 37.902v55.636h.044Z",
    fill: "#fff"
  }), /* @__PURE__ */ React7.createElement("path", {
    d: "M55.14 56.694h14.438v20.235h-7.22V66.81H55.14V56.694Zm25.283 0H94.86v20.235h-7.22V66.81h-7.218V56.694Z",
    fill: "#9514FF"
  }));
}
var Blooblob2_default = SvgBlooblob2;

// src/react/Blooblob3.tsx
import * as React8 from "react";
function SvgBlooblob3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React8.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React8.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React8.createElement("path", {
    d: "M120.165 116.837H29.79V61.201A37.902 37.902 0 0 1 67.694 23.3H82.22a37.902 37.902 0 0 1 37.902 37.902v55.636h.044Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React8.createElement("path", {
    d: "M55.14 56.683h14.438v20.246h-7.22V66.81H55.14V56.683Zm25.283 0H94.86v20.246h-7.22V66.81h-7.218V56.683Z",
    fill: "#2089FA"
  }));
}
var Blooblob3_default = SvgBlooblob3;

// src/react/Blooblob4.tsx
import * as React9 from "react";
function SvgBlooblob4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React9.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React9.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React9.createElement("path", {
    d: "M120.165 116.837H29.79V61.201A37.902 37.902 0 0 1 67.694 23.3H82.22a37.902 37.902 0 0 1 37.902 37.902v55.636h.044Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React9.createElement("path", {
    d: "M55.14 56.694h14.438v20.235h-7.22V66.81H55.14V56.694Zm25.283 0H94.86v20.235h-7.22V66.81h-7.218V56.694Z",
    fill: "#fff"
  }));
}
var Blooblob4_default = SvgBlooblob4;

// src/react/Blooblob5.tsx
import * as React10 from "react";
function SvgBlooblob5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React10.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React10.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React10.createElement("path", {
    d: "M120.165 116.837H29.79V61.201A37.902 37.902 0 0 1 67.694 23.3H82.22a37.902 37.902 0 0 1 37.902 37.902v55.636h.044Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React10.createElement("path", {
    d: "M55.14 56.683h14.438v20.246h-7.22V66.81H55.14V56.683Zm25.283 0H94.86v20.246h-7.22V66.81h-7.218V56.683Z",
    fill: "#fff"
  }));
}
var Blooblob5_default = SvgBlooblob5;

// src/react/Chaos1.tsx
import * as React11 from "react";
function SvgChaos1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React11.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React11.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M29.835 49.331h90.374v37.252a37.902 37.902 0 0 1-37.902 37.903h-14.57a37.903 37.903 0 0 1-37.902-37.903V49.331Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M29.835 50.489V30.772l25.283 19.717H29.835Zm90.33 0V30.772L94.883 50.489h25.282Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M60.606 65.434h-7.44v7.439h7.44v-7.44Zm0 7.45h-7.44v7.44h7.44v-7.44Zm7.44-7.45h-7.44v7.439h7.44v-7.44Zm0 7.45h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M60.606 76.61h-7.44v11.164h7.44V76.609Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M68.046 80.323h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M74.581 101.749h-7.44v7.439h7.44v-7.439Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M82.02 101.749h-7.439v7.439h7.44v-7.439Zm-7.439-7.451h-7.44v7.44h7.44v-7.44Zm7.439 0h-7.439v7.44h7.44v-7.44Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M88.435 65.434h-7.44v7.439h7.44v-7.44Zm0 7.45h-7.44v7.44h7.44v-7.44Zm7.439-7.45h-7.439v7.439h7.44v-7.44Zm0 7.45h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M88.435 76.61h-7.44v11.164h7.44V76.609Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React11.createElement("path", {
    d: "M95.874 80.323h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Chaos1_default = SvgChaos1;

// src/react/Chaos2.tsx
import * as React12 from "react";
function SvgChaos2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React12.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React12.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M29.835 49.331h90.374v37.253a37.905 37.905 0 0 1-37.902 37.902h-14.57a37.902 37.902 0 0 1-37.902-37.902V49.33Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M29.835 50.489V30.772l25.283 19.717H29.835Zm90.33 0V30.772L94.882 50.489h25.283Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M60.606 65.433h-7.44v7.44h7.44v-7.44Zm0 7.451h-7.44v7.44h7.44v-7.44Zm7.44-7.451h-7.44v7.44h7.44v-7.44Zm0 7.451h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M60.606 76.61h-7.44v11.164h7.44V76.609Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M68.046 80.323h-7.44v7.44h7.44v-7.44Zm3.229 21.426h-7.44v7.439h7.44v-7.439Z",
    fill: "#fff"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M78.714 101.749h-7.44v7.439h7.44v-7.439Zm7.451 0h-7.44v7.439h7.44v-7.439Zm2.27-36.316h-7.44v7.44h7.44v-7.44Zm0 7.451h-7.44v7.44h7.44v-7.44Zm7.439-7.451h-7.439v7.44h7.44v-7.44Zm0 7.451h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M88.435 76.61h-7.44v11.164h7.44V76.609Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React12.createElement("path", {
    d: "M95.874 80.323h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Chaos2_default = SvgChaos2;

// src/react/Chaos3.tsx
import * as React13 from "react";
function SvgChaos3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React13.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React13.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React13.createElement("path", {
    d: "M29.835 49.331h90.374v37.253a37.905 37.905 0 0 1-37.902 37.902h-14.57a37.902 37.902 0 0 1-37.902-37.902V49.33Z",
    fill: "#000"
  }), /* @__PURE__ */ React13.createElement("path", {
    d: "M29.835 50.489V30.772l25.283 19.717H29.835Zm90.33 0V30.772L94.883 50.489h25.282Z",
    fill: "#000"
  }), /* @__PURE__ */ React13.createElement("path", {
    d: "M53.167 69.853h14.438v20.235h-7.22V79.971h-7.218V69.853Zm25.283 0h14.437v20.235h-7.219V79.971H78.45V69.853Z",
    fill: "#F7FC17"
  }));
}
var Chaos3_default = SvgChaos3;

// src/react/Chaos4.tsx
import * as React14 from "react";
function SvgChaos4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React14.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React14.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React14.createElement("path", {
    d: "M29.835 49.331h90.374v37.253a37.905 37.905 0 0 1-37.902 37.902h-14.57a37.902 37.902 0 0 1-37.902-37.902V49.33Z",
    fill: "#fff"
  }), /* @__PURE__ */ React14.createElement("path", {
    d: "M29.835 50.489V30.772l25.283 19.717H29.835Zm90.33 0V30.772L94.883 50.489h25.282Z",
    fill: "#fff"
  }), /* @__PURE__ */ React14.createElement("path", {
    d: "M53.167 69.853h14.438v20.235h-7.22V79.971h-7.218V69.853Zm25.283 0h14.437v20.235h-7.219V79.971H78.45V69.853Z",
    fill: "#9514FF"
  }));
}
var Chaos4_default = SvgChaos4;

// src/react/Chaos5.tsx
import * as React15 from "react";
function SvgChaos5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React15.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React15.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React15.createElement("path", {
    d: "M29.835 49.331h90.374v37.253a37.905 37.905 0 0 1-37.902 37.902h-14.57a37.902 37.902 0 0 1-37.902-37.902V49.33Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React15.createElement("path", {
    d: "M29.835 50.489V30.772l25.283 19.717H29.835Zm90.33 0V30.772L94.883 50.489h25.282Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React15.createElement("path", {
    d: "M53.167 69.853h14.438v20.235h-7.22V79.971h-7.218V69.853Zm25.283 0h14.437v20.235h-7.219V79.971H78.45V69.853Z",
    fill: "#F7FC17"
  }));
}
var Chaos5_default = SvgChaos5;

// src/react/Firebob1.tsx
import * as React16 from "react";
function SvgFirebob1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React16.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React16.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#000"
  }), /* @__PURE__ */ React16.createElement("path", {
    d: "M121.202 29.868 99.457 77.645h21.039a48.166 48.166 0 0 1-29.795 44.468 48.164 48.164 0 0 1-65.623-35.215 48.163 48.163 0 0 1 47.365-57.471V49.53l48.759-19.662ZM74.747 96.249V77.645H61.422v9.313h6.613v9.291h6.712Zm-19.662 0V77.645H41.782v9.313h6.613v9.291h6.69Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React16.createElement("path", {
    d: "M74.747 77.634v18.648H68.09v-9.324h-6.646v-9.324h13.303Zm-19.663 0v18.648h-6.657v-9.324h-6.646v-9.324h13.303Z",
    fill: "#fff"
  }));
}
var Firebob1_default = SvgFirebob1;

// src/react/Firebob2.tsx
import * as React17 from "react";
function SvgFirebob2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React17.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React17.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React17.createElement("path", {
    d: "M121.201 29.912 99.456 77.689h21.04a48.17 48.17 0 0 1-29.826 44.437 48.158 48.158 0 0 1-52.467-10.554 48.16 48.16 0 0 1-10.326-52.513 48.163 48.163 0 0 1 44.566-29.632V49.53l48.758-19.618ZM74.747 96.326v-18.68H61.422v9.323h6.613v9.313l6.712.044Zm-19.662 0v-18.68H41.782v9.323h6.613v9.313l6.69.044Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React17.createElement("path", {
    d: "M74.747 77.645v18.637H68.09v-9.324h-6.646v-9.313h13.303Zm-19.663 0v18.637h-6.657v-9.324h-6.646v-9.313h13.303Z",
    fill: "#000"
  }));
}
var Firebob2_default = SvgFirebob2;

// src/react/Firebob3.tsx
import * as React18 from "react";
function SvgFirebob3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React18.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React18.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#000",
    fillOpacity: 0.85
  }), /* @__PURE__ */ React18.createElement("path", {
    d: "M121.201 29.912 99.456 77.689h21.04a48.17 48.17 0 0 1-29.826 44.437 48.158 48.158 0 0 1-52.467-10.554 48.16 48.16 0 0 1-10.326-52.513 48.163 48.163 0 0 1 44.566-29.632V49.53l48.758-19.618ZM74.747 96.326v-18.68H61.422v9.323h6.613v9.313l6.712.044Zm-19.662 0v-18.68H41.782v9.323h6.613v9.313l6.69.044Z",
    fill: "#fff"
  }), /* @__PURE__ */ React18.createElement("path", {
    d: "M74.747 77.645v18.637H68.09v-9.324h-6.646v-9.313h13.303Zm-19.663 0v18.637h-6.657v-9.324h-6.646v-9.313h13.303Z",
    fill: "#FF5509"
  }));
}
var Firebob3_default = SvgFirebob3;

// src/react/Firebob4.tsx
import * as React19 from "react";
function SvgFirebob4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React19.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React19.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#fff"
  }), /* @__PURE__ */ React19.createElement("path", {
    d: "M121.202 29.868 99.457 77.645h21.039a48.166 48.166 0 0 1-29.795 44.468 48.164 48.164 0 0 1-65.623-35.215 48.163 48.163 0 0 1 47.365-57.471V49.53l48.759-19.662ZM74.747 96.249V77.645H61.422v9.313h6.613v9.291h6.712Zm-19.662 0V77.645H41.782v9.313h6.613v9.291h6.69Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React19.createElement("path", {
    d: "M74.747 77.634v18.648H68.09v-9.324h-6.646v-9.324h13.303Zm-19.663 0v18.648h-6.657v-9.324h-6.646v-9.324h13.303Z",
    fill: "#fff"
  }));
}
var Firebob4_default = SvgFirebob4;

// src/react/Firebob5.tsx
import * as React20 from "react";
function SvgFirebob5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React20.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React20.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React20.createElement("path", {
    d: "M121.201 29.912 99.456 77.689h21.04a48.17 48.17 0 0 1-29.826 44.437 48.158 48.158 0 0 1-52.467-10.554 48.16 48.16 0 0 1-10.326-52.513 48.163 48.163 0 0 1 44.566-29.632V49.53l48.758-19.618ZM74.747 96.326v-18.68H61.422v9.323h6.613v9.313l6.712.044Zm-19.662 0v-18.68H41.782v9.323h6.613v9.313l6.69.044Z",
    fill: "#fff"
  }), /* @__PURE__ */ React20.createElement("path", {
    d: "M74.747 77.645v18.637H68.09v-9.324h-6.646v-9.313h13.303Zm-19.663 0v18.637h-6.657v-9.324h-6.646v-9.313h13.303Z",
    fill: "#000"
  }));
}
var Firebob5_default = SvgFirebob5;

// src/react/Firebob6.tsx
import * as React21 from "react";
function SvgFirebob6(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React21.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React21.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#878F92"
  }), /* @__PURE__ */ React21.createElement("path", {
    d: "M121.202 29.868 99.457 77.645h21.039a48.167 48.167 0 0 1-29.795 44.468 48.164 48.164 0 0 1-65.623-35.215 48.163 48.163 0 0 1 47.365-57.471V49.53l48.759-19.662ZM74.747 96.249V77.645H61.422v9.313h6.613v9.291h6.712Zm-19.662 0V77.645H41.782v9.313h6.613v9.291h6.69Z",
    fill: "#AFB4B6"
  }), /* @__PURE__ */ React21.createElement("path", {
    d: "M74.747 77.634v18.648H68.09v-9.324h-6.646v-9.324h13.303Zm-19.663 0v18.648h-6.657v-9.324h-6.646v-9.324h13.303Z",
    fill: "#fff"
  }));
}
var Firebob6_default = SvgFirebob6;

// src/react/Glitchy1.tsx
import * as React22 from "react";
function SvgGlitchy1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React22.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React22.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React22.createElement("path", {
    d: "M71.308 25.404a44.592 44.592 0 0 0-44.581 44.592 44.581 44.581 0 0 0 44.58 44.581h44.626v-44.58a44.593 44.593 0 0 0-44.625-44.592Z",
    fill: "#fff"
  }), /* @__PURE__ */ React22.createElement("path", {
    d: "M54.743 66.271h-7.44v7.44h7.44v-7.44Zm-7.44-7.451h-7.439v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Zm-14.89 14.912h-7.439v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Zm24.005-7.461h-7.44v7.44h7.44v-7.44Zm-7.44-7.451h-7.44v7.44h7.44v-7.44Zm14.879 0h-7.44v7.44h7.44v-7.44ZM78.758 73.732h-7.44v7.44h7.44v-7.44Zm14.879 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#9514FF"
  }));
}
var Glitchy1_default = SvgGlitchy1;

// src/react/Glitchy2.tsx
import * as React23 from "react";
function SvgGlitchy2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React23.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React23.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React23.createElement("path", {
    d: "M71.308 25.404a44.592 44.592 0 0 0-44.581 44.592 44.581 44.581 0 0 0 44.58 44.581h44.626v-44.58a44.593 44.593 0 0 0-44.625-44.592Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React23.createElement("path", {
    d: "M54.743 66.271h-7.44v7.44h7.44v-7.44Zm-7.44-7.451h-7.439v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Zm-14.89 14.912h-7.439v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Zm24.005-7.461h-7.44v7.44h7.44v-7.44Zm-7.44-7.451h-7.44v7.44h7.44v-7.44Zm14.879 0h-7.44v7.44h7.44v-7.44ZM78.758 73.732h-7.44v7.44h7.44v-7.44Zm14.879 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#FF14D5"
  }));
}
var Glitchy2_default = SvgGlitchy2;

// src/react/Glitchy3.tsx
import * as React24 from "react";
function SvgGlitchy3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React24.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React24.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React24.createElement("path", {
    d: "M71.308 25.415a44.582 44.582 0 0 0-44.581 44.592 44.581 44.581 0 0 0 44.58 44.582h44.626V70.007a44.581 44.581 0 0 0-44.625-44.592Z",
    fill: "#fff"
  }), /* @__PURE__ */ React24.createElement("path", {
    d: "M51.855 62.248h14.438v20.246h-7.219V72.377h-7.219V62.248Zm25.283 0h14.438v20.246h-7.219V72.377h-7.219V62.248Z",
    fill: "#9514FF"
  }));
}
var Glitchy3_default = SvgGlitchy3;

// src/react/Glitchy4.tsx
import * as React25 from "react";
function SvgGlitchy4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React25.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React25.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React25.createElement("path", {
    d: "M71.308 25.415a44.582 44.582 0 0 0-44.581 44.592 44.581 44.581 0 0 0 44.58 44.582h44.626V70.007a44.581 44.581 0 0 0-44.625-44.592Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React25.createElement("path", {
    d: "M51.855 62.248h14.438v20.246h-7.219V72.377h-7.219V62.248Zm25.283 0h14.438v20.246h-7.219V72.377h-7.219V62.248Z",
    fill: "#000"
  }));
}
var Glitchy4_default = SvgGlitchy4;

// src/react/Glitchy5.tsx
import * as React26 from "react";
function SvgGlitchy5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React26.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React26.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React26.createElement("path", {
    d: "M71.308 25.415a44.582 44.582 0 0 0-44.581 44.592 44.581 44.581 0 0 0 44.58 44.582h44.626V70.007a44.581 44.581 0 0 0-44.625-44.592Z",
    fill: "#fff"
  }), /* @__PURE__ */ React26.createElement("path", {
    d: "M51.855 62.248h14.438v20.246h-7.219V72.366h-7.219V62.248Zm25.283 0h14.438v20.246h-7.219V72.366h-7.219V62.248Z",
    fill: "#00DB83"
  }));
}
var Glitchy5_default = SvgGlitchy5;

// src/react/Igor1.tsx
import * as React27 from "react";
function SvgIgor1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React27.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React27.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#000"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M36.062 70.8h77.722v20.941a32.613 32.613 0 0 1-32.612 32.612H68.674a32.614 32.614 0 0 1-32.612-32.568V70.801Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M110.478 63.34h21.304a20.942 20.942 0 0 1-20.941 20.94h-.352l-.011-20.94Zm-70.956 0H18.23a20.94 20.94 0 0 0 20.94 20.94h.342l.011-20.94Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M113.938 76.565H36.216v-20.94a32.612 32.612 0 0 1 32.612-32.612h12.498a32.61 32.61 0 0 1 32.612 32.611v20.94Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M61.874 63.18h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M61.874 70.619h-7.44v7.439h7.44v-7.44Zm7.45 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M69.324 63.18h-7.44v11.164h7.44V63.179Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M69.324 78.07h-7.44v7.439h7.44v-7.44Zm-7.45 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M89.702 48.733h-7.44v7.44h7.44v-7.44Zm7.44-7.45h-7.44v7.44h7.44v-7.44Zm-35.566 14.89h7.44v-7.44h-7.44v7.44Zm-7.45-7.44h7.439v-7.439h-7.44v7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M89.702 70.619h-7.44v7.439h7.44v-7.44Zm7.44-7.439h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M97.142 70.619h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M89.702 63.18h-7.44v11.164h7.44V63.179Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React27.createElement("path", {
    d: "M97.142 78.07h-7.44v7.439h7.44v-7.44Zm-7.44 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Igor1_default = SvgIgor1;

// src/react/Igor2.tsx
import * as React28 from "react";
function SvgIgor2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React28.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React28.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M36.062 70.8h77.722v20.941a32.613 32.613 0 0 1-32.612 32.612H68.674a32.614 32.614 0 0 1-32.612-32.568V70.801Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M110.478 63.34h21.304a20.942 20.942 0 0 1-20.941 20.94h-.352l-.011-20.94Zm-70.956 0H18.23a20.94 20.94 0 0 0 20.94 20.94h.342l.011-20.94Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M113.938 76.565H36.216v-20.94a32.612 32.612 0 0 1 32.612-32.612h12.498a32.61 32.61 0 0 1 32.612 32.611v20.94Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M61.874 63.18h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M61.874 70.619h-7.44v7.439h7.44v-7.44Zm7.45 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M69.324 63.18h-7.44v11.164h7.44V63.179Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M69.324 78.07h-7.44v7.439h7.44v-7.44Zm-7.45 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M89.702 48.733h-7.44v7.44h7.44v-7.44Zm7.44-7.45h-7.44v7.44h7.44v-7.44Zm-35.566 14.89h7.44v-7.44h-7.44v7.44Zm-7.45-7.44h7.439v-7.439h-7.44v7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M89.702 70.619h-7.44v7.439h7.44v-7.44Zm7.44-7.439h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M97.142 70.619h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M89.702 63.18h-7.44v11.164h7.44V63.179Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React28.createElement("path", {
    d: "M97.142 78.07h-7.44v7.439h7.44v-7.44Zm-7.44 0h-7.44v7.439h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Igor2_default = SvgIgor2;

// src/react/Igor3.tsx
import * as React29 from "react";
function SvgIgor3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React29.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React29.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React29.createElement("path", {
    d: "M36.073 70.812h77.711v20.94a32.616 32.616 0 0 1-32.601 32.668H68.685a32.612 32.612 0 0 1-32.612-32.612V70.812Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React29.createElement("path", {
    d: "M110.478 63.35h21.304a20.942 20.942 0 0 1-20.941 20.941h-.352l-.011-20.94Zm-70.956 0H18.23a20.94 20.94 0 0 0 20.94 20.941h.342l.011-20.94Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React29.createElement("path", {
    d: "M113.938 76.576H36.216v-20.94a32.612 32.612 0 0 1 32.612-32.613h12.498a32.61 32.61 0 0 1 32.612 32.612v20.94Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React29.createElement("path", {
    d: "M54.49 64.927h14.437v20.246h-7.219V75.044H54.49V64.927Zm25.282 0H94.21v20.246h-7.219V75.044h-7.219V64.927Z",
    fill: "#1C70F7"
  }));
}
var Igor3_default = SvgIgor3;

// src/react/Igor4.tsx
import * as React30 from "react";
function SvgIgor4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React30.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React30.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#000"
  }), /* @__PURE__ */ React30.createElement("path", {
    d: "M36.073 70.812h77.711v20.94a32.616 32.616 0 0 1-32.601 32.668H68.685a32.612 32.612 0 0 1-32.612-32.612V70.812Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React30.createElement("path", {
    d: "M110.478 63.35h21.304a20.942 20.942 0 0 1-20.941 20.941h-.352l-.011-20.94Zm-70.956 0H18.23a20.94 20.94 0 0 0 20.94 20.941h.342l.011-20.94Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React30.createElement("path", {
    d: "M113.938 76.576H36.216v-20.94a32.612 32.612 0 0 1 32.612-32.613h12.498a32.61 32.61 0 0 1 32.612 32.612v20.94Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React30.createElement("path", {
    d: "M54.49 64.927h14.437v20.246h-7.219V75.044H54.49V64.927Zm25.282 0H94.21v20.246h-7.219V75.044h-7.219V64.927Z",
    fill: "#9514FF"
  }));
}
var Igor4_default = SvgIgor4;

// src/react/Igor5.tsx
import * as React31 from "react";
function SvgIgor5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React31.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React31.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React31.createElement("path", {
    d: "M36.073 70.8h77.711v20.941a32.608 32.608 0 0 1-32.612 32.612H68.685a32.614 32.614 0 0 1-32.612-32.568V70.801Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React31.createElement("path", {
    d: "M110.478 63.35h21.304a20.942 20.942 0 0 1-20.941 20.94h-.352l-.011-20.94Zm-70.956 0H18.23a20.94 20.94 0 0 0 20.94 20.94h.342l.011-20.94Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React31.createElement("path", {
    d: "M113.938 76.576H36.216v-20.94a32.613 32.613 0 0 1 32.612-32.613h12.498a32.612 32.612 0 0 1 32.612 32.612v20.94Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React31.createElement("path", {
    d: "M54.49 63.824h14.437V84.07h-7.219V73.942H54.49V63.824Zm25.282 0H94.21V84.07h-7.219V73.942h-7.219V63.824Z",
    fill: "#fff"
  }));
}
var Igor5_default = SvgIgor5;

// src/react/Inkly1.tsx
import * as React32 from "react";
function SvgInkly1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React32.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React32.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React32.createElement("path", {
    d: "M120.165 90.562H29.791v-29.36a37.903 37.903 0 0 1 37.902-37.903h14.526a37.902 37.902 0 0 1 37.902 37.902v29.361h.044Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React32.createElement("path", {
    d: "M51.128 79.938H29.835v31.002h21.293V79.938Zm69.037 0H98.872v31.002h21.293V79.938Zm-34.519 0H64.353v31.002h21.293V79.938Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React32.createElement("path", {
    d: "M62.039 55.15h-7.44v7.44h7.44v-7.44ZM54.6 62.623h-7.44v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44ZM94.2 55.15h-7.44v7.44h7.44v-7.44Zm-7.44 7.473h-7.44v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#1E69FF"
  }));
}
var Inkly1_default = SvgInkly1;

// src/react/Inkly2.tsx
import * as React33 from "react";
function SvgInkly2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React33.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React33.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React33.createElement("path", {
    d: "M120.165 90.562H29.791v-29.36a37.903 37.903 0 0 1 37.902-37.903h14.526a37.902 37.902 0 0 1 37.902 37.902v29.361h.044Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React33.createElement("path", {
    d: "M51.128 79.938H29.835v31.002h21.293V79.938Zm69.037 0H98.872v31.002h21.293V79.938Zm-34.519 0H64.353v31.002h21.293V79.938Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React33.createElement("path", {
    d: "M62.039 55.15h-7.44v7.44h7.44v-7.44ZM54.6 62.623h-7.44v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44ZM94.2 55.15h-7.44v7.44h7.44v-7.44Zm-7.44 7.473h-7.44v7.44h7.44v-7.44Zm14.89 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#F7FC17"
  }));
}
var Inkly2_default = SvgInkly2;

// src/react/Inkly3.tsx
import * as React34 from "react";
function SvgInkly3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React34.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React34.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React34.createElement("path", {
    d: "M120.165 92.573H29.791v-29.36a37.903 37.903 0 0 1 37.946-37.87h14.482a37.903 37.903 0 0 1 37.902 37.903v29.327h.044Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React34.createElement("path", {
    d: "M51.128 81.938H29.835v31.002h21.293V81.938Zm69.037 0H98.872v31.002h21.293V81.938Zm-34.518 0H64.353v31.002h21.294V81.938Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React34.createElement("path", {
    d: "M54.038 52.125h14.438v20.246h-7.22V62.243h-7.218V52.125Zm25.282 0h14.438v20.246H86.54V62.243h-7.22V52.125Z",
    fill: "#F7FC17"
  }));
}
var Inkly3_default = SvgInkly3;

// src/react/Inkly4.tsx
import * as React35 from "react";
function SvgInkly4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React35.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React35.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React35.createElement("path", {
    d: "M120.165 92.573H29.791v-29.36a37.903 37.903 0 0 1 37.946-37.87h14.482a37.903 37.903 0 0 1 37.902 37.903v29.327h.044Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React35.createElement("path", {
    d: "M51.128 81.938H29.835v31.002h21.293V81.938Zm69.037 0H98.872v31.002h21.293V81.938Zm-34.518 0H64.353v31.002h21.294V81.938Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React35.createElement("path", {
    d: "M54.038 52.125h14.438v20.246h-7.22V62.243h-7.218V52.125Zm25.282 0h14.438v20.246H86.54V62.243h-7.22V52.125Z",
    fill: "#1E69FF"
  }));
}
var Inkly4_default = SvgInkly4;

// src/react/Inkly5.tsx
import * as React36 from "react";
function SvgInkly5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React36.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React36.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React36.createElement("path", {
    d: "M120.165 92.573H29.791v-29.36A37.902 37.902 0 0 1 67.693 25.31h14.526a37.902 37.902 0 0 1 37.902 37.902v29.361h.044Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React36.createElement("path", {
    d: "M51.128 81.938H29.835v31.002h21.293V81.938Zm69.037 0H98.872v31.002h21.293V81.938Zm-34.518 0H64.353v31.002h21.294V81.938Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React36.createElement("path", {
    d: "M54.038 52.125h14.438V72.36h-7.22V62.243h-7.218V52.125Zm25.282 0h14.438V72.36H86.54V62.243h-7.22V52.125Z",
    fill: "#28EBEB"
  }));
}
var Inkly5_default = SvgInkly5;

// src/react/Maddog1.tsx
import * as React37 from "react";
function SvgMaddog1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React37.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React37.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#FF5509"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "m29.776 50.618 90.374.174-.071 37.24a37.898 37.898 0 0 1-11.169 26.796 37.896 37.896 0 0 1-26.85 11.034l-14.549-.028a37.903 37.903 0 0 1-37.829-37.975l.072-37.24h.022Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "m29.814 30.714 3.427.007a19.905 19.905 0 0 1 19.867 19.943l-23.332-.045.038-19.905Zm90.317 20.056-23.332-.045a19.904 19.904 0 0 1 19.943-19.866l3.427.006-.038 19.905Z",
    fill: "#28EBEB"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M61.135 64.982h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M70.966 108.56h7.44v-7.44h-7.44v7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M64.342 108.56h7.44v-7.44h-7.44v7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M57.266 103.248h7.44v-7.44h-7.44v7.44Zm20.842 5.312h7.44v-7.44h-7.44v7.44Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M61.135 72.42h-7.44v7.44h7.44v-7.44Zm7.45-7.438h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M68.585 72.42h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M61.135 76.146h-7.44v11.165h7.44V76.146Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M68.585 79.871h-7.439v7.44h7.44v-7.44Zm20.379-14.889h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M88.964 72.42h-7.44v7.44h7.44v-7.44Zm7.439-7.438h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M96.403 72.42h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M88.964 76.146h-7.44v11.165h7.44V76.146Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React37.createElement("path", {
    d: "M96.403 79.871h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Maddog1_default = SvgMaddog1;

// src/react/Maddog2.tsx
import * as React38 from "react";
function SvgMaddog2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React38.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React38.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React38.createElement("path", {
    d: "m29.776 50.619 90.374.173-.071 37.241a37.918 37.918 0 0 1-11.153 26.78 37.898 37.898 0 0 1-26.822 11.05l-14.593-.028A37.915 37.915 0 0 1 32.54 102.37a37.905 37.905 0 0 1-2.857-14.51l.072-37.241h.022Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React38.createElement("path", {
    d: "m29.814 30.715 3.427.006a19.905 19.905 0 0 1 19.867 19.943l-23.332-.045.038-19.904Zm90.317 20.065-23.332-.044a19.904 19.904 0 0 1 19.943-19.866l3.427.006-.038 19.905Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React38.createElement("path", {
    d: "M120.176 67.98H29.945v7.505h90.231v-7.506Z",
    fill: "#000"
  }), /* @__PURE__ */ React38.createElement("path", {
    d: "M46.532 67.98h-7.506v19.066h7.506V67.98Zm15.011 29.867h7.505V67.968h-7.505v29.88Zm-7.506 0h7.506V67.968h-7.506v29.88Zm-7.505 0h7.505V67.968h-7.505v29.88Zm57.046-10.812h7.505V67.968h-7.505v19.067ZM88.567 67.98H81.06v29.878h7.506V67.979Zm7.505 0h-7.505v29.878h7.505V67.979Zm7.506 0h-7.506v29.878h7.506V67.979Z",
    fill: "#000"
  }));
}
var Maddog2_default = SvgMaddog2;

// src/react/Maddog3.tsx
import * as React39 from "react";
function SvgMaddog3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React39.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React39.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React39.createElement("path", {
    d: "m30.428 50.67 90.346 2.287-.943 37.229a37.906 37.906 0 0 1-11.784 26.519 37.896 37.896 0 0 1-27.087 10.411l-14.543-.368a37.913 37.913 0 0 1-26.512-11.776 37.898 37.898 0 0 1-10.42-27.073l.943-37.23Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React39.createElement("path", {
    d: "m53.244 71.749 14.427.364-.507 20.235-7.219-.177.254-10.117-7.22-.188.265-10.117Zm25.272.639 14.438.364-.518 20.246-7.22-.188.265-10.117-7.218-.188.253-10.117Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React39.createElement("path", {
    d: "m30.93 30.758 3.427.087A19.905 19.905 0 0 1 53.75 51.247l-23.324-.59.503-19.899Zm89.813 22.172-23.325-.59a19.906 19.906 0 0 1 20.402-19.395l3.427.087-.504 19.898Z",
    fill: "#00DB83"
  }));
}
var Maddog3_default = SvgMaddog3;

// src/react/Maddog4.tsx
import * as React40 from "react";
function SvgMaddog4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React40.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React40.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React40.createElement("path", {
    d: "m30.428 50.67 90.346 2.287-.943 37.229a37.906 37.906 0 0 1-11.784 26.519 37.896 37.896 0 0 1-27.087 10.411l-14.543-.368a37.913 37.913 0 0 1-26.512-11.776 37.898 37.898 0 0 1-10.42-27.073l.943-37.23Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React40.createElement("path", {
    d: "m53.244 71.749 14.427.364-.507 20.235-7.219-.177.254-10.117-7.22-.188.265-10.117Zm25.272.639 14.438.364-.518 20.246-7.22-.188.265-10.117-7.218-.188.253-10.117Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React40.createElement("path", {
    d: "m30.93 30.758 3.427.087A19.905 19.905 0 0 1 53.75 51.247l-23.324-.59.503-19.899Zm89.813 22.172-23.325-.59a19.906 19.906 0 0 1 20.402-19.395l3.427.087-.504 19.898Z",
    fill: "#1E69FF"
  }));
}
var Maddog4_default = SvgMaddog4;

// src/react/Maddog5.tsx
import * as React41 from "react";
function SvgMaddog5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React41.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React41.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0C33.578 0 0 33.579 0 75s33.578 75 75 75Z",
    fill: "#9514FF"
  }), /* @__PURE__ */ React41.createElement("path", {
    d: "M29.831 51.8h90.375v37.241a37.902 37.902 0 0 1-37.902 37.902H67.778a37.898 37.898 0 0 1-35.017-23.397 37.905 37.905 0 0 1-2.886-14.505V51.8h-.044Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React41.createElement("path", {
    d: "M53.166 72.3h14.438v20.246h-7.219V82.417h-7.219V72.3Zm25.284 0h14.437v20.246h-7.219V82.417H78.45V72.3Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React41.createElement("path", {
    d: "M29.831 31.885h3.428A19.905 19.905 0 0 1 53.163 51.8H29.831V31.885Zm90.323 19.905H96.822a19.906 19.906 0 0 1 19.904-19.905h3.428v19.904Z",
    fill: "#F7FC17"
  }));
}
var Maddog5_default = SvgMaddog5;

// src/react/Reaper1.tsx
import * as React42 from "react";
function SvgReaper1(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React42.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React42.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React42.createElement("path", {
    d: "M29.835 48.273h90.374v37.241a37.886 37.886 0 0 1-11.109 26.831 37.89 37.89 0 0 1-26.837 11.094H67.737a37.905 37.905 0 0 1-35.023-23.413 37.904 37.904 0 0 1-2.88-14.512v-37.24Z",
    fill: "#000"
  }), /* @__PURE__ */ React42.createElement("path", {
    d: "m29.835 48.273 29.89-21.69-7.87 23.134h-22.02m90.33-1.444-29.89-21.69 7.88 23.134h22.01",
    fill: "#000"
  }), /* @__PURE__ */ React42.createElement("path", {
    d: "M55.558 74.581H48.12v7.44h7.44v-7.44Zm7.451 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React42.createElement("path", {
    d: "M70.448 74.581h-7.44v7.44h7.44v-7.44Zm16.532 0h-7.44v7.44h7.44v-7.44Zm7.45 0h-7.439v7.44h7.44v-7.44Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React42.createElement("path", {
    d: "M101.87 74.581h-7.44v7.44h7.44v-7.44Z",
    fill: "#FF14D5"
  }));
}
var Reaper1_default = SvgReaper1;

// src/react/Reaper2.tsx
import * as React43 from "react";
function SvgReaper2(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React43.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React43.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React43.createElement("path", {
    d: "M29.835 48.273h90.374v37.241a37.886 37.886 0 0 1-11.109 26.831 37.89 37.89 0 0 1-26.837 11.094H67.737a37.905 37.905 0 0 1-35.023-23.413 37.904 37.904 0 0 1-2.88-14.512v-37.24Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React43.createElement("path", {
    d: "m29.835 48.273 29.89-21.69-7.87 23.134h-22.02m90.33-1.444-29.89-21.69 7.88 23.134h22.01",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React43.createElement("path", {
    d: "M55.558 74.581H48.12v7.44h7.44v-7.44Zm7.451 0h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React43.createElement("path", {
    d: "M70.448 74.581h-7.44v7.44h7.44v-7.44Zm16.532 0h-7.44v7.44h7.44v-7.44Zm7.45 0h-7.439v7.44h7.44v-7.44Z",
    fill: "#fff"
  }), /* @__PURE__ */ React43.createElement("path", {
    d: "M101.87 74.581h-7.44v7.44h7.44v-7.44Z",
    fill: "#fff"
  }));
}
var Reaper2_default = SvgReaper2;

// src/react/Reaper3.tsx
import * as React44 from "react";
function SvgReaper3(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React44.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React44.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#1E69FF"
  }), /* @__PURE__ */ React44.createElement("path", {
    d: "M29.835 48.273h90.374v37.241a37.901 37.901 0 0 1-37.902 37.903h-14.57a37.903 37.903 0 0 1-37.902-37.903v-37.24Z",
    fill: "#00DB83"
  }), /* @__PURE__ */ React44.createElement("path", {
    d: "m29.835 48.273 29.89-21.69-7.88 23.134h-22.01m90.33-1.444-29.89-21.69 7.87 23.134h22.02",
    fill: "#00DB83"
  }), /* @__PURE__ */ React44.createElement("path", {
    d: "M52.792 69.17H67.23v20.246h-7.219V79.287h-7.219V69.17Zm25.283 0h14.438v20.246h-7.22V79.287h-7.218V69.17Z",
    fill: "#1E69FF"
  }));
}
var Reaper3_default = SvgReaper3;

// src/react/Reaper4.tsx
import * as React45 from "react";
function SvgReaper4(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React45.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React45.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#F7FC17"
  }), /* @__PURE__ */ React45.createElement("path", {
    d: "M29.835 48.273h90.374v37.241a37.901 37.901 0 0 1-37.902 37.903h-14.57a37.903 37.903 0 0 1-37.902-37.903v-37.24Z",
    fill: "#000"
  }), /* @__PURE__ */ React45.createElement("path", {
    d: "m29.835 48.273 29.89-21.69-7.88 23.134h-22.01m90.33-1.444-29.89-21.69 7.87 23.134h22.02",
    fill: "#000"
  }), /* @__PURE__ */ React45.createElement("path", {
    d: "M52.792 69.17H67.23v20.246h-7.219V79.287h-7.219V69.17Zm25.283 0h14.438v20.246h-7.22V79.287h-7.218V69.17Z",
    fill: "#FF5509"
  }));
}
var Reaper4_default = SvgReaper4;

// src/react/Reaper5.tsx
import * as React46 from "react";
function SvgReaper5(_a) {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React46.createElement("svg", __spreadValues({
    fill: "none",
    height: 150,
    viewBox: "0 0 150 150",
    width: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */ React46.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75Z",
    fill: "#64D965"
  }), /* @__PURE__ */ React46.createElement("path", {
    d: "M29.835 48.273h90.374v37.241a37.902 37.902 0 0 1-37.902 37.902h-14.57a37.902 37.902 0 0 1-37.902-37.902v-37.24Z",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React46.createElement("path", {
    d: "m29.835 48.273 29.89-21.69-7.88 23.134h-22.01m90.33-1.444-29.89-21.69 7.87 23.134h22.02",
    fill: "#FF14D5"
  }), /* @__PURE__ */ React46.createElement("path", {
    d: "M52.792 69.17H67.23v20.235h-7.219V79.287h-7.219V69.17Zm25.283 0h14.438v20.235h-7.22V79.287h-7.218V69.17Z",
    fill: "#fff"
  }));
}
var Reaper5_default = SvgReaper5;

// src/NxRandomAvatar.tsx
import React47, { useMemo } from "react";

// src/RandomAvatars.helpers.ts
var avatarsByPersona = {
  Bender: [
    react_exports.Bender1,
    react_exports.Bender2,
    react_exports.Bender3,
    react_exports.Bender4,
    react_exports.Bender5
  ],
  Blooblob: [
    react_exports.Blooblob1,
    react_exports.Blooblob2,
    react_exports.Blooblob3,
    react_exports.Blooblob4,
    react_exports.Blooblob5
  ],
  Chaos: [
    react_exports.Chaos1,
    react_exports.Chaos2,
    react_exports.Chaos3,
    react_exports.Chaos4,
    react_exports.Chaos5
  ],
  Firebob: [
    react_exports.Firebob1,
    react_exports.Firebob2,
    react_exports.Firebob3,
    react_exports.Firebob4,
    react_exports.Firebob5,
    react_exports.Firebob6
  ],
  Glitchy: [
    react_exports.Glitchy1,
    react_exports.Glitchy2,
    react_exports.Glitchy3,
    react_exports.Glitchy4,
    react_exports.Glitchy5
  ],
  Igor: [
    react_exports.Igor1,
    react_exports.Igor2,
    react_exports.Igor3,
    react_exports.Igor4,
    react_exports.Igor5
  ],
  Inkly: [
    react_exports.Inkly1,
    react_exports.Inkly2,
    react_exports.Inkly3,
    react_exports.Inkly4,
    react_exports.Inkly5
  ],
  Maddog: [
    react_exports.Maddog1,
    react_exports.Maddog2,
    react_exports.Maddog3,
    react_exports.Maddog4,
    react_exports.Maddog5
  ],
  Reaper: [
    react_exports.Reaper1,
    react_exports.Reaper2,
    react_exports.Reaper3,
    react_exports.Reaper4,
    react_exports.Reaper5
  ]
};

// src/NxRandomAvatar.tsx
var randomAvatarsWithoutDisabled = Object.entries(react_exports).filter((avatar) => avatar[0] !== "Firebob6");
function NxRandomAvatar(_a) {
  var _b = _a, {
    hashId,
    persona,
    personaIndex
  } = _b, rest = __objRest(_b, [
    "hashId",
    "persona",
    "personaIndex"
  ]);
  let avatars;
  if (persona) {
    avatars = avatarsByPersona[persona].map((avatar) => ["", avatar]);
  } else {
    avatars = randomAvatarsWithoutDisabled;
  }
  const randomAvatarIndex = useMemo(() => {
    if (hashId) {
      const computedHash = hashId.split("").reduce((acc, nextChar) => (acc + nextChar.charCodeAt(0)) % 256, 0);
      return computedHash % avatars.length;
    }
    return Math.floor(Math.random() * avatars.length);
  }, [hashId]);
  const RandomAvatar = avatars[personaIndex || randomAvatarIndex][1];
  return /* @__PURE__ */ React47.createElement(RandomAvatar, __spreadValues({}, rest));
}
export {
  NxRandomAvatar,
  react_exports as NxRandomAvatars
};
//# sourceMappingURL=index.js.map